import { AppDefinition } from '../../types/apps';

/**
 * Minimal AppDefinition for the Store. Used by QuickLauncher + CommandPalette
 * as a fallback when the registered-apps endpoint is unavailable.
 *
 * Historical taxonomy (categories, subcategories, pricing types, etc.) lived
 * here but was never actually consumed — it's gone.
 */
export const StoreAppDefinition: AppDefinition = {
  appId: 'store',
  name: 'Store',
  version: '2.0.0',
  description:
    'Marketplace for discovering apps, tools, automations, integrations, space templates, models, and corpora.',
  icon: {
    type: 'phosphor',
    phosphorIcon: 'Storefront',
    phosphorWeight: 'duotone',
    color: '#f97316',
  },
  events: {
    itemInstalled: 'Item successfully installed',
    itemPurchased: 'Item purchased',
  },
  entityTypes: [],
  component: 'StoreApp',
  requiresEntity: false,
  requiresProps: false,
};
